module.exports = __webpack_public_path__ + "static/media/promineo-large-icon.5acb3be3.svg";